import { getFirebase } from "react-redux-firebase";
import Notiflix from "notiflix";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { ENDPOINTS } from "../config";
import { cancelConfirmMessage, createPhoneBooking, diffReservation, updateReservation } from "../services/reservationsApi";
import { formatAuDate } from "../utils/reservationDisplay";

export const SignUpOnWebApp = (newUser, history) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    dispatch({ type: "RESETERROR" });
    const firebase = getFirebase();
    await firebase
      .createUser({
        email: newUser.Email.toLowerCase(),
        password: newUser.Pass,
      })
      .catch((err) => {
        dispatch({ type: "SIGNUP_ERROR", err });
        Notiflix.Loading.Remove();
      });
    const { authError } = getState().state;
    if (!authError) {
      await firebase
        .updateProfile({
          createdAt: new Date(),
          displayName: newUser.Name,
          avatarUrl: null,
        })
        .then(() => {
          const { uid } = getState().firebase.auth;
          dispatch({ type: "USERINFO", payload: uid });
          history.push("/Home");
          Notiflix.Loading.Remove();
        })
        .catch((err) => {
          Notiflix.Loading.Remove();
          dispatch({ type: "SIGNUP_ERROR", err });
        });
    }
  };
};
export const Logout = (history) => {
  return async (dispatch) => {
    const firebase = getFirebase();
    await firebase
      .logout()
      .then(dispatch({ type: "SETINITIALSTATE" }))
      .catch((err) => {
        dispatch({ type: "SIGNUP_ERROR", err });
      });
    history.push("/");
  };
};

export const LoginToWebApp = (email, pass) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    dispatch({ type: "RESETERROR" });
    const firebase = getFirebase();
    await firebase
      .login({
        email: email,
        password: pass,
      })
      .catch((err) => {
        dispatch({ type: "SIGNUP_ERROR", err });
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("wrong credentials", `${err.message}`, "Close");
      });
    const { authError } = getState().state;
    if (!authError) {
      const { uid } = getState().firebase.auth;
      dispatch({ type: "USERINFO", payload: uid });
      Notiflix.Loading.Remove();
    }
    Notiflix.Loading.Remove();
  };
};

export const AddMenu = (data) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    const { uid } = getState().firebase.auth;
    const menuID = uuidv4();

    var obj = {
      menuBizId: data["bizId"],
      menuName: data["menuName"],
      menuDesc: data["Dis"],
      menuOnTime: data["MenuON"],
      menuOffTime: data["MenuOFF"],
      menuOn: data["MenuISOn"],
      menuType: data["MenuType"],
    };
    // { MenuType, MenuON, MenuOFF, MenuISOn, Dis, bizId }
    var obj2 = { createdOn: new Date(), uid: uid, menuId: menuID };
    Object.assign(obj, obj2);
    await firebase
      .firestore()
      .collection("MenuDetails")
      .doc(menuID)
      .set(obj)
      .catch((err) => {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

export const MenuONOFF = (data, value) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    const { uid } = getState().firebase.auth;
    const menuID = uuidv4();
    await firebase
      .firestore()
      .collection("MenuDetails")
      .doc(data)
      .update({ menuOn: !value })
      .catch((err) => {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

export const AddDish = (data) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    const { uid } = getState().firebase.auth;
    const DishID = uuidv4();
    var counter = 0;
    var listArray = Object.keys(data.images);
    async function callBack(downloadURL) {
      if (listArray.length === counter) {
        const DishImage = downloadURL;
        var obj = data;
        var obj2 = {
          timestamp: new Date(),
          uid: uid,
          dishID: DishID,
          DishImage,
        };
        Object.assign(obj, obj2);
        
        await firebase
          .firestore()
          .collection("DishDetails")
          .doc(DishID)
          .set(obj)
          .catch((err) => {
            Notiflix.Loading.Remove();
            Notiflix.Report.Failure(
              "Something went wrong",
              `${err.message}`,
              "Close"
            );
          });
        
        Notiflix.Loading.Remove();
      }
    }
    listArray.forEach(async function(element) {
      await firebase
        .storage()
        .ref(`DishDetails/${DishID}/${element}`)
        .putString(data.images[element], "data_url", {
          contentType: "image/jpg",
        })
        .catch((err) => {
          Notiflix.Loading.Remove();
          Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
        });
      const downloadURL = await firebase
        .storage()
        .ref(`DishDetails/${DishID}/${element}`)
        .getDownloadURL()
        .catch((err) => {
          dispatch({ type: "SIGNUP_ERROR", err });
        });
      counter = counter + 1;
      callBack(downloadURL);
    });
  };
};

export const DishONOFF = (data, value) => {
  
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    await firebase
      .firestore()
      .collection("DishDetails")
      .doc(data)
      .update({ dishOn: !value })
      .catch((err) => {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

export const DishDelete = (data) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    await firebase
      .firestore()
      .collection("DishDetails")
      .doc(data)
      .delete()
      .catch((err) => {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

export const MenuUpdate = (data, value) => {
  return async (dispatch, getState) => {
    // changing data types
    data = {
      menuName: data["menuName"],
      menuDesc: data["Dis"],
      menuOnTime: data["MenuON"],
      menuOffTime: data["MenuOFF"],
      menuType: data["MenuType"],
      MenuIDForUpdating: data["MenuIDForUpdating"],
    };

    

    const {
      menuDesc,
      menuOnTime,
      menuOffTime,
      menuType,
      MenuIDForUpdating,
      menuName,
    } = data;

    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    await firebase
      .firestore()
      .collection("MenuDetails")
      .doc(MenuIDForUpdating)
      .update({
        menuDesc: menuDesc,
        menuOnTime: menuOnTime,
        menuOffTime: menuOffTime,
        menuType: menuType,
        menuName: menuName,
      })
      .catch((err) => {
        
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

export const DishUpdate = (data) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    const DishID = data.RecordedDishID;
    var counter = 0;
    var listArray = Object.keys(data.images);
    async function callBack(downloadURL) {
      if (listArray.length === counter) {
        const DishImage = downloadURL;
        await firebase
          .firestore()
          .collection("DishDetails")
          .doc(data.DishIDForUpdating)
          .update({
            dishCal: data.dishCal,
            dishDesc: data.dishDesc,
            dishTransFat: data.dishTransFat,
            dishAvailFrom: data.dishAvailFrom,
            dishAvailTill: data.dishAvailTill,
            dishName: data.dishName,
            // DishPrice1: data.DishPrice1,
            // DishPrice2: data.DishPrice2,
            // DishPrice3: data.DishPrice3,
            // DishPrice4: data.DishPrice4,
            dishAvailSize: data.dishAvailSize,
            dishPolySatFat: data.dishPolySatFat,
            dishMonoFat: data.dishMonoFat,
            images: data.images,
            dishSatFat: data.dishSatFat,
            dishTotFat: data.dishTotFat,
            DishImage: DishImage,
          })
          .catch((err) => {
            Notiflix.Loading.Remove();
            Notiflix.Report.Failure(
              "Something went wrong",
              `${err.message}`,
              "Close"
            );
          });
        
        Notiflix.Loading.Remove();
      }
    }
    listArray.forEach(async function(element) {
      await firebase
        .storage()
        .ref(`DishDetails/${DishID}/${element}`)
        .putString(data.images[element], "data_url", {
          contentType: "image/jpg",
        })
        .catch((err) => {
          Notiflix.Loading.Remove();
          Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
        });
      const downloadURL = await firebase
        .storage()
        .ref(`DishDetails/${DishID}/${element}`)
        .getDownloadURL()
        .catch((err) => {
          dispatch({ type: "SIGNUP_ERROR", err });
        });
      counter = counter + 1;
      callBack(downloadURL);
    });
  };
};

export const SetDishOption = async (dishId, dishOption) => {
  Notiflix.Loading.Hourglass("Please Wait...");
  const firebase = getFirebase();

  await firebase
    .firestore()
    .collection(`DishDetails/${dishId}/dishOptions`)
    .doc(dishOption["id"])
    .set(dishOption)
    // TOTO HERE ADDE remove hour class
    .catch((err) => {
      Notiflix.Loading.Remove();
      Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
    });
  
  Notiflix.Loading.Remove();
};

export const SetTableBiz = async (bizId, tables) => {
  Notiflix.Loading.Hourglass("Please Wait...");
  const firestore = getFirebase().firestore();

  const batch = firestore.batch();
  const ref = firestore.collection(`Business/${bizId}/Tables`);

  tables.forEach((t) => {
    var docRef;
    docRef = ref.doc(`${t["tableNo"]}`);

    batch.set(docRef, t);
  });

  await batch.commit().catch((err) => {
    Notiflix.Loading.Remove();
    Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
  });
  Notiflix.Loading.Remove();
};

export const DeleteTables = async (bizId, tables) => {
  Notiflix.Loading.Hourglass("Please Wait...");
  const firestore = getFirebase().firestore();

  const batch = firestore.batch();
  const ref = firestore.collection(`Business/${bizId}/Tables`);

  tables.forEach((t) => {
    var docRef = ref.doc(`${t["tableNo"]}`); // doc id
    if (`${t["tableNo"]}`) {
      batch.delete(docRef);
    }
  });

  await batch.commit().catch((err) => {
    Notiflix.Loading.Remove();
    Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
  });
  Notiflix.Loading.Remove();
};

export const DishOptionDelete = async (dishId, dishOption) => {
  
  Notiflix.Loading.Hourglass("Please Wait...");
  const firebase = getFirebase();
  await firebase
    .firestore()
    .collection(`DishDetails/${dishId}/dishOptions`)
    .doc(dishOption["id"])
    .delete()
    .catch((err) => {
      Notiflix.Loading.Remove();
      Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
    });
  Notiflix.Loading.Remove();
};

export const DishOptionTrigers = (data, value) => {
  return async (dispatch, getState) => {
    
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    await firebase
      .firestore()
      .collection("DishDetails")
      .doc(data)
      .update({ [value.data]: value.value })
      .catch((err) => {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

// Reservation writes go through the newFunctions staff API (fix 6); client
// Firestore writes to Reservations are being locked down. See
// src/services/reservationsApi.js for the contract. Each returns true on success.

// "Booking saved: Thu 05/11/2026, 19:30–20:30" so staff can check what was stored
export const bookingSavedMessage = (r) => {
  const date = formatAuDate(r?.reservationDate);
  const times = [r?.timeFrom, r?.timeTo].filter(Boolean).join("–");
  const detail = [date, times].filter(Boolean).join(", ");
  return detail ? `Booking saved: ${detail}` : "Booking saved";
};

const reservationErrorMessage = (err) => `${err?.message || err || "Something went wrong"}`;

const reportReservationError = (err) => {
  Notiflix.Loading.Remove();
  Notiflix.Report.Failure("Couldn't save the reservation", reservationErrorMessage(err), "Close");
};

// Add and edit return { ok, data } or { ok: false, message } and do NOT pop an
// error themselves: the modal stays open and shows the message. Status changes
// (no modal) still report errors with Notiflix.

export const AddReservations = async (reservation, bizId) => {
  Notiflix.Loading.Hourglass("Please Wait...");
  try {
    const data = await createPhoneBooking(bizId, reservation);
    Notiflix.Loading.Remove();
    Notiflix.Notify.Success(bookingSavedMessage(data?.reservation || reservation));
    return { ok: true, data };
  } catch (err) {
    Notiflix.Loading.Remove();
    return { ok: false, message: reservationErrorMessage(err) };
  }
};

const isCancel = (status) => status === "canceled" || status === "removed";

// Cancelling refunds a customer's deposit server-side, so staff confirm first.
const confirmCancel = (reservation) =>
  typeof window === "undefined" || window.confirm(cancelConfirmMessage(reservation));

const reportCancelResult = (status, res) => {
  if (status !== "canceled") return;
  const note = {
    refunded: "Booking canceled. The deposit has been refunded.",
    already_refunded: "Booking canceled. The deposit had already been refunded.",
  }[res?.depositRefund] || "Booking canceled.";
  Notiflix.Notify.Success(note);
};

// Sends only the fields that changed (PATCH), never the whole doc.
export const EditReservation = async (original, edited, bizId) => {
  const changes = diffReservation(original, edited);
  if (Object.keys(changes).length === 0) return { ok: true, data: null, changes };
  if (isCancel(changes.reservationStatus) && !confirmCancel(original)) {
    return { ok: false, cancelled: true, message: "" };
  }
  Notiflix.Loading.Hourglass("Please Wait...");
  try {
    const data = await updateReservation(bizId, original.reservationId, changes);
    Notiflix.Loading.Remove();
    if (isCancel(changes.reservationStatus)) reportCancelResult(changes.reservationStatus, data);
    else Notiflix.Notify.Success(bookingSavedMessage({ ...original, ...changes }));
    return { ok: true, data, changes };
  } catch (err) {
    Notiflix.Loading.Remove();
    return { ok: false, message: reservationErrorMessage(err) };
  }
};

export const ChangeResevationStatus = async (reservation, status, bizId) => {
  if (isCancel(status) && !confirmCancel(reservation)) return { ok: false, cancelled: true };
  Notiflix.Loading.Hourglass("Please Wait...");
  try {
    const data = await updateReservation(bizId, reservation.reservationId, { reservationStatus: status });
    Notiflix.Loading.Remove();
    reportCancelResult(status, data);
    return { ok: true, data };
  } catch (err) {
    reportReservationError(err);
    return { ok: false, message: reservationErrorMessage(err) };
  }
};

// biztypes

export const AddBiz = (data, history) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    const { uid } = getState().firebase.auth;
    let docRef = firebase
      .firestore()
      .collection("Business")
      .doc();
    // const bizId = uuidv4();
    var counter = 0;
    var listArray = Object.keys(data.images);
    let images = [];
    async function callBack(downloadURL) {
      if (listArray.length === counter) {
        const BizImage = downloadURL;
        var obj = data;

        obj["images"] = images;
        var obj2 = {
          timestamp: new Date(),
          uid: uid,
          bizId: docRef.id,
          bizPic1: BizImage,
          bizSource: 'website_owner',
        };
        Object.assign(obj, obj2);
        

        await docRef.set(obj).catch((err) => {
          Notiflix.Loading.Remove();
          Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
        });

        await firebase.firestore().doc(`VenueManagement/${uid}`).set(
          {
            uid,
            venueIds: firebase.firestore.FieldValue.arrayUnion(docRef.id),
          },
          { merge: true }
        ).catch((err) => {
          console.error('Failed to update VenueManagement:', err);
        });

        history.push("/Home");
        Notiflix.Loading.Remove();
      }
    }
    listArray.forEach(async function(element) {
      await firebase
        .storage()
        .ref(`Business/${docRef.id}/${element}`)
        .putString(data.images[element], "data_url", {
          contentType: "image/jpg",
        })
        .catch((err) => {
          Notiflix.Loading.Remove();
          Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
        });
      const downloadURL = await firebase
        .storage()
        .ref(`Business/${docRef.id}/${element}`)
        .getDownloadURL()
        .catch((err) => {
          dispatch({ type: "SIGNUP_ERROR", err });
        });
      images.push(downloadURL);
      counter = counter + 1;
      callBack(downloadURL);
    });
  };
};

// `venueDocId` is the Business doc ID. It is passed separately so the
// `bizId` field is never written here: mobile reviews/reservations still
// reference existing bizId values, which must only change via a migration.
export const editBiz = (data, history, venueDocId) => {
  return async (dispatch, getState) => {
    if (!venueDocId) {
      Notiflix.Report.Failure("Something went wrong", "Missing venue ID", "Close");
      return;
    }
    Notiflix.Loading.Hourglass("Please Wait...");

    const firebase = getFirebase();
    const { uid } = getState().firebase.auth;

    const listArray = Object.keys(data.images);
    const images = [];
    let counter = 0;

    // Helper to sanitize data (remove undefined fields)
    const sanitizeData = (obj) => {
      const clean = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== undefined) {
          clean[key] = obj[key];
        }
      });
      return clean;
    };

    // Callback after all images uploaded
    const handleComplete = async () => {
      let updatedData = {
        ...data,
        images,
        bizPic1: images[0] || "",
        timestamp: new Date(),
        uid,
      };


      const docRef = firebase
        .firestore()
        .collection("Business")
        .doc(venueDocId);
      const docSnap = await docRef.get();

      // Remove temporary fields, and never touch the bizId field
      delete updatedData.oldImages;
      delete updatedData.bizId;

      // Remove undefined fields
      updatedData = sanitizeData(updatedData);
      if (docSnap.exists) {
        await docRef
          .update(updatedData)
          .then(() => {
            Notiflix.Loading.Remove();
            Notiflix.Notify.Success("Business updated successfully");
            history.push("/");
          })
          .catch((err) => {
            Notiflix.Loading.Remove();
            Notiflix.Report.Failure(
              "Something went wrong",
              `${err.message}`,
              "Close"
            );
          });
      }
    };

    // Upload images one by one
    for (const element of listArray) {
      try {
        await firebase
          .storage()
          .ref(`Business/${venueDocId}/${element}`)
          .putString(data.images[element], "data_url", {
            contentType: "image/jpg",
          });

        const downloadURL = await firebase
          .storage()
          .ref(`Business/${venueDocId}/${element}`)
          .getDownloadURL();

        images.push(downloadURL);
        counter++;

        if (counter === listArray.length) {
          await handleComplete();
        }
      } catch (err) {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Upload failed", `${err.message}`, "Close");
        dispatch({ type: "EDIT_BIZ_ERROR", err });
        return;
      }
    }
  };
};

const getorderListString = (orderItem) => {
  let order = "";
  for (let item of orderItem.dishes ?? []) {
    let count = item.dishCount;
    order = order + `${count} ${item.dishName}${count > 1 ? "s" : ""} `;
  }

  return order;
};

const sendNotification = async (status, item, accesstoken, bizName) => {
  // send notification accourding to status

  try {
    let headers = {
      Authorization: `Bearer ${accesstoken}`,
    };

    let data = {
      userid: item.userId,
      message: "",
    };

    if (status === "preparing") {
      data.message = `Your order of ${getorderListString(
        item
      )} has been received at ${bizName} and is about to be started`;
    } else if (status === "completed") {
      const baseMsg = `“Your order of ${getorderListString(
        item
      )} at ${bizName} has been complete and`;
      let uponMsg = `${baseMsg} please step forward to pick-it-up or keep an eye/ear open or if the venue would be so kind to recognise your disability they may go the extra mile`;

      let seatedMsg = `${baseMsg} the venue may be so kind to bring it to the location where you scanned this QR code. Either way, remain alert!`;

      data.message =
        item.orderPaymentType === "ON_APPROACH" ? uponMsg : seatedMsg;
    } else if (status === "CANCELLED") {
      data.message = `Your order at ${bizName} of ${getorderListString(
        item
      )} has been cancelled by the venue.`;
    } else if (status === "REFUNDED") {
      data.message = `Your order at ${bizName} of ${getorderListString(
        item
      )} has been canceled and refunded.`;
    }

    let res = await axios.post(
      ENDPOINTS.userNotify,
      data,
      { headers }
    );

    return res.data;
  } catch (err) {
    
  }
};

const refund = async (orderId, accesstoken, bizId) => {
  // refund

  try {
    let headers = {
      Authorization: `Bearer ${accesstoken}`,
    };

    let data = {
      orderId: orderId,
      bizId: bizId,
    };


    let res = await axios.post(
      ENDPOINTS.refund,
      data,
      { headers }
    );

    return res.data;
  } catch (err) {
    if (err.response.data) {
      return err.response.data;
    }
    return {
      refunded: false,
      error: err,
    };
  }
};

export const SetOrderStatus = (item, value, access_token, bizName) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");
    const firebase = getFirebase();
    await firebase
      .firestore()
      .collection("Orders")
      .doc(item.id)
      .update({ OrderStatus: value })
      .then(() => {
        sendNotification(value, item, access_token, bizName);
      })
      .catch((err) => {
        Notiflix.Loading.Remove();
        Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
      });
    Notiflix.Loading.Remove();
  };
};

export const RefundUserOrder = (item, bizId, bizName, access_token) => {
  return async (dispatch, getState) => {
    Notiflix.Loading.Hourglass("Please Wait...");

    const res = await refund(item.orderId, access_token, bizId).catch((e) => {
      if (e.refunded) {
        return e;
      }
      return {
        refunded: false,
        error: `${e}`,
      };
    });

    if (res.refunded) {
      Notiflix.Loading.Remove();
      sendNotification("REFUNDED", item, access_token, bizName);
      Notiflix.Report.Success("The order was refunded succesfully");
    } else {
      Notiflix.Loading.Remove();
      Notiflix.Report.Failure("Something went wrong", `${res.error}`, "Close");
    }
  };
};

export const ResetPass = (email, history) => {
  return async (dispatch, getState) => {
    const firebase = getFirebase();
    await firebase.resetPassword(email).catch((err) => {
      Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Ok");
    });
    history.push("/");
    Notiflix.Report.Success(
      "Password reseted Successfully",
      "Please check your email Inbox (or Spam/Junk) to choose a new password",
      "Ok"
    );
  };
};

export const setNotifySound = (notify) => {
  return {
    type: "SETNOTIFY",
    payload: notify,
  };
};

// export const TestAPI = () => {
//   return async (dispatch, getState) => {
//     const firebase = getFirebase();

//     const snapshot = await firebase.firestore().collection('DishDetails').get()
//     const data = snapshot.docs.map(doc => doc.data())
//     data.forEach(async element => {
//       if (element.bizId===6) {
//         const DishID = uuidv4();
//         
//         await firebase
//         .firestore()
//         .collection("Dishes")
//         .doc(DishID)
//         .set({
//           Dis:"",
//           DishName:element.dishName,
//           DishISOn:true,
//           DishFrom:"08:00",
//           DishTill:"21:30",
//           MenuType:element.menuName,
//           DishPrice1:element.dishPrice1,
//           DishPrice2:element.dishPrice2,
//           DishPrice3:element.dishPrice3,
//           DishPrice4:element.dishPrice4,
//           MenuIDForDish:element.menuName==="Drinks"?"d96f87b4-acd7-4f57-9da7-5757d78665d6":"bba4c3ed-ea3c-4d5f-8a6f-c91924d0bebb",
//           DishImage:"https://firebasestorage.googleapis.com/v0/b/wine-n-dine-30dab.appspot.com/o/dish.png?alt=media&token=5cbe6679-8085-4738-b8ca-bc929e7dc3ac",
//           bizId:"14f5fb30-f17f-4ffa-969a-6ef4abde641a",
//           DishID:DishID,
//           timestamp:new Date(),
//           uid:"b4IgBCrZoUW54TbYf06pxQi5ZL52"
//         })
//         .catch((err) => {
//           Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
//         });

//         // const menuID = uuidv4();
//         // 
//         // await firebase
//         // .firestore()
//         // .collection("Menus")
//         // .doc(menuID)
//         // .set({
//         //   Dis:element.menuName,
//         //   MenuISOn:true,
//         //   MenuOFF:element.menuOffTime,
//         //   MenuON:"08:00",
//         //   MenuType:element.menuName,
//         //   bizId:"14f5fb30-f17f-4ffa-969a-6ef4abde641a",
//         //   menuID:menuID,
//         //   timestamp:new Date(),
//         //   uid:"b4IgBCrZoUW54TbYf06pxQi5ZL52"
//         // })
//         // .catch((err) => {
//         //   Notiflix.Report.Failure("Something went wrong", `${err.message}`, "Close");
//         // });
//       }
//     });

//   };
// };

export const UpdatePassword = (oldPassword, newPassword, history) => {
  return async (dispatch) => {
    const firebase = getFirebase();
    const user = firebase.auth().currentUser;
    if (!user || !user.email) {
      Notiflix.Report.Failure("Error", "No authenticated user found.", "Close");
      return;
    }
    try {
      Notiflix.Loading.Hourglass("Updating password...");
      const credential = firebase.auth.EmailAuthProvider.credential(user.email, oldPassword);
      await user.reauthenticateWithCredential(credential);
      await user.updatePassword(newPassword);
      Notiflix.Loading.Remove();
      Notiflix.Report.Success("Success", "Password updated successfully.", "OK");
    } catch (err) {
      Notiflix.Loading.Remove();
      Notiflix.Report.Failure("Error", err.message, "Close");
    }
  };
};

export const UploadUserAvatar = (images, history) => {
  return async (dispatch) => {
    const firebase = getFirebase();
    const user = firebase.auth().currentUser;
    if (!user) return;
    const imageKey = Object.keys(images)[0];
    if (!imageKey || !images[imageKey]) return;
    try {
      Notiflix.Loading.Hourglass("Uploading avatar...");
      const storageRef = firebase.storage().ref();
      const avatarRef = storageRef.child(`avatars/${user.uid}`);
      const response = await fetch(images[imageKey]);
      const blob = await response.blob();
      await avatarRef.put(blob);
      const url = await avatarRef.getDownloadURL();
      await firebase.firestore().collection("Users").doc(user.uid).update({ avatarUrl: url });
      Notiflix.Loading.Remove();
      Notiflix.Report.Success("Success", "Avatar uploaded.", "OK");
    } catch (err) {
      Notiflix.Loading.Remove();
      Notiflix.Report.Failure("Error", err.message, "Close");
    }
  };
};
